// @flow
import type { LedgerCategory } from '../types';

const ledgerCategories: Array<LedgerCategory> = [
  { id: '1', name: 'Assets' },
  { id: '3', name: 'Liabilities' },
  { id: '5', name: 'Equity' },
  { id: '6', name: 'Revenues' },
  { id: '7', name: 'Operating Expenses' },
  { id: '8', name: 'Cost of Sales' },
  { id: '9', name: 'Personal/Business Holding' },
];

export default ledgerCategories;
